/**
 * BackButton Component
 * Reusable back button for modals with proper chevron styling
 */

'use client';

import { IconChevronUp , IconX} from '@tabler/icons-react';
import { Cbutton } from '../ui/Cbutton';
import { ButtonPreset } from '@/constants/componentPresets';
import { useViewport } from '@/hooks/dom';
import { Viewport } from '@/theme/breakpoints';

export interface BackButtonProps {
  onClick: () => void;
}

export function BackButton({ onClick }: BackButtonProps) {
  const { viewport } = useViewport();
  const isMobile = viewport === Viewport.Mobile;

	  return (
	    <Cbutton

	      icon={IconX}
      iconSize={isMobile ? 20 : 20}
      iconOpacity={0.65}
      preset={ButtonPreset.Secondary}
      containerStyle={{
        boxShadow:
          "rgba(255, 255, 255, 0.12) 0.7px 0.9px 1.1px 0px inset, rgba(0, 0, 0, 0.06) -0.5px -0.4px 0.5px 0px inset, #00000009 2px 3px 5px 0px",
        }}
      onClick={onClick}
    />
  );
}
